import { HttpEvent, HttpInterceptorFn, HttpRequest, HttpResponse } from "@angular/common/http";
import { map } from "rxjs";
import { CaseHelper } from "@shared/helpers/case.helper";

const EXCEPTIONAL_URLS: string[] = ["es.json", "en.json", "pt.json"];

function isExceptionalUrl(request: HttpRequest<unknown>): boolean {
  return EXCEPTIONAL_URLS.some((url: string) => request.url.includes(url));
}

function shouldTransformResponseBody(body: unknown): boolean {
  return body != null && !(body instanceof Blob) && !(body instanceof ArrayBuffer);
}

export const responseTransformInterceptor: HttpInterceptorFn = (request, next) =>
  next(request).pipe(
    map((event: HttpEvent<unknown>) => {
      if (
        event instanceof HttpResponse &&
        shouldTransformResponseBody(event.body) &&
        !isExceptionalUrl(request)
      ) {
        const transformedBody: unknown = CaseHelper.toCamelCase(event.body);
        return event.clone({ body: transformedBody });
      }

      return event;
    }),
  );
